<template>
  <div class="app-container">
    <div v-if="user">
      <el-row :gutter="20">
        <el-col :span="6" :xs="24">
          <user-card :user="user" />
        </el-col>

        <el-col :span="18" :xs="24">
          <el-card>
            <el-tabs v-model="activeTab">
              <el-tab-pane label="个人信息" name="activity">
                <!-- <activity /> -->
                <el-button
                  type="success"
                  class="el-icon-lock"
                  size="mini"
                  @click="pwVisible = true"
                ></el-button>
              </el-tab-pane>
              <!-- 修改密码弹窗 -->
              <el-dialog title="修改密码" :visible.sync="pwVisible" width="28%" :modal="true" center>
                <el-form
                  :model="formpw"
                  :rules="rules"
                  ref="formpw"
                  label-width="80px"
                  style="margin-left:15%"
                >
                  <el-row>
                    <el-form-item label="当前密码" prop="password">
                      <el-input
                        v-model="formpw.password"
                        style="width:170px"
                        type="password"
                        show-password
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="新的密码" prop="uppassword">
                      <el-input
                        v-model="formpw.uppassword"
                        style="width:170px"
                        type="password"
                        show-password
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checkPass2">
                      <el-input
                        type="password"
                        v-model="formpw.checkPass2"
                        autocomplete="off"
                        style="width:170px"
                        show-password
                      ></el-input>
                    </el-form-item>
                  </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="pwVisible = false">取 消</el-button>
                  <el-button type="primary" @click="updatepassword()">确 定</el-button>
                </span>
              </el-dialog>
            </el-tabs>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserCard from "./components/UserCard";
import Activity from "./components/Activity";
import Timeline from "./components/Timeline";
import Account from "./components/Account";
import { updatepasswordself } from "@/api/orgin";
import { getToken, setToken, removeToken, getname } from '@/utils/auth'
export default {
  name: "Profile",
  components: { UserCard, Activity, Timeline, Account },
  data() {
    // 修改密码校验
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formpw.uppassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      pwVisible: false,
      //修改密码了
      formpw: {
        password: "",
        uppassword: "",
        checkPass2: ""
      },
      user: {},
      activeTab: "activity",
      rules: {
        uppassword: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        checkPass2: [{ validator: validatePass3, trigger: "blur" }],
        password:[{ required: true, message: "请输入当前密码", trigger: "blur"}],
      }
    };
  },
  computed: {
    ...mapGetters(["name", "avatar", "roles"])
  },
  created() {
    this.getUser();
  },
  methods: {
    //修改密码
    updatepassword() {
      setTimeout(() => {
        updatepasswordself({
          password_old: this.formpw.password,
          password_new: this.formpw.uppassword
        }).then(response => {
          if (response.status_code == 200) {
            this.$message({
              type: "success",
              message: "修改成功! 即将返回登录页"
            });
            this.pwVisible = false;
            setTimeout(() => {
               removeToken()
               this.$router.push('/login')
            }, 1000);
          } else {
            this.$message({
              type: "warning",
              message: "修改失败!服务器出错"
            });
          }
        });
      }, 100);
    },
    getUser() {
      this.user = {
        name: getname(),
        role: this.roles.join(" | "),
        email: "admin@test.com",
        avatar:
          "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif"
      };
    },
  }
};
</script>
